module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second.b9fa849c.svg";